import { MDXLayout } from "@/shared/components/MDX/MDXLayout";
import Content from "../../help/bom-revisions.mdx";

export function BomRevisionsHelpPage() {
  return (
    <MDXLayout>
      <Content />
    </MDXLayout>
  );
}
